import { Component, OnInit, inject } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { AppVersionService } from './shared/services/app-version.service';

// the second parameter 'fr' is optional
registerLocaleData(localeEs, 'es-ES');
registerLocaleData(localeEs, 'es');

@Component({
    selector: 'convfact-app',
    template: `<router-outlet></router-outlet>`,
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {
  private readonly appVersion = inject(AppVersionService);

  ngOnInit(): void {
    this.appVersion.start();
  }
}